module.exports = __webpack_public_path__ + "static/media/kkaebangjung.490c7934.png";